import { CHAT_STATUS } from '@whatsper/texterchat-common';
export const STATUS_LABEL_KEYS = {
    [CHAT_STATUS.PENDING]: 'pending',
    [CHAT_STATUS.ASSIGNED]: 'taken',
};
export const DEFAULT_SETTINGS = { enabled: false, hours: 48 };
export const DEFAULT_IDLE_THRESHOLD_HOURS = 24;
export const HOUR_PRESETS = ['12', '24', '36', '48', '72'];
export const MAX_HOURS = 300;
